<script setup lang="ts">
import DVPPortMonitor from './components/DVPPortMonitor.vue'
</script>

<template>
  <DVPPortMonitor />
</template>
